module.exports = __webpack_public_path__ + "static/default_articlePic-6c5016223aa459cffef26df966a624af.jpg";